import Resource from './Resource';

export default class CoursesRequest extends Resource {
	constructor(options={}) {
		let {
			route = '',
			query = {},
			data = {}
		} = options;

		let config = {
			route: route,
			query: query,
			data: data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}
}
